import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';

export const CumulativeDistanceReportModule = new Module({
  id: 'cumulative-distance-report',
  name: 'Cumulative Distance Report',
  path: 'cumulative-distance-report',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/CumulativeDistance'))
  )
});
